import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as UserActions from './user.actions';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import UserService from '../../services/UserService';

@Injectable()
export class UserEffects {
  loadUserMe$;

  constructor(
    private actions$: Actions,
    private userService: UserService
  ) {
    this.loadUserMe$ = createEffect(() =>
      this.actions$.pipe(
        ofType(UserActions.loadUserMe),
        mergeMap(() =>
          this.userService.getMe().pipe(
            map((userMeResponse) =>
              UserActions.loadUserMeSuccess({ userMeResponse })
            ),
            catchError((error) =>
              of(UserActions.loadUserMeFailure({ error }))
            )
          )
        )
      )
    );
  }
}
